import { render, staticRenderFns } from "./TranslationControls.vue?vue&type=template&id=15322778&scoped=true&lang=html&"
import script from "./TranslationControls.vue?vue&type=script&lang=js&"
export * from "./TranslationControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15322778",
  null
  
)

export default component.exports